/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTkuMiAxNC41QzEyLjggMTQuNSAxNS43IDExLjYgMTUuNyA4QzE1LjcgNC40IDEyLjggMS41IDkuMiAxLjVDNS42IDEuNSAyLjggNC40IDIuOCA4SDAuMTk5OTk3TDMuMiAxMUw2LjIgOEgzLjhDMy44IDUgNi4zIDIuNSA5LjMgMi41QzEyLjMgMi41IDE0LjggNSAxNC44IDhDMTQuOCAxMSAxMi4zIDEzLjUgOS4zIDEzLjVWMTQuNUg5LjJaIiBmaWxsPSJpbmhlcml0Ii8+";